import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'


Vue.use(Router)

const routerOptions = [{
  path: '/',
  component: Main,
}]


const rou = new Router({
  mode: 'history',
  routes: routerOptions
})


export default rou;